import axiosInstance from '../../../config/axiosInstance';
const CustomerStockService = {
    async GetAllCustomerStock(redirectCallback, ClientCompanyID) {
        try {
            const response = await axiosInstance.get(`/Customer/GetCustomerStock?ID=${ClientCompanyID}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async CustomerStockCategory(redirectCallback, ClientCompanyID) {
        try {
            const response = await axiosInstance.get(`/Customer/CustomerStockCategory?ID=${ClientCompanyID}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteCustomerStock(ID, redirectCallback) {
        try {
            const response = await axiosInstance.get(`/Customer/DeleteCustomerStock?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting team:', error);
            throw error;
        }
    },
    async GetAllParts(redirectCallback, Start, PageSize, searchQuery, sortColumn, sortDirection, CustomerID = 0, SearchColumns) {
        try {
            debugger;
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem('UserID');
            const response = await axiosInstance.get(`/Customer/GetAllParts?ClientID=${ClientID}&Start=${Start}&PageSize=${PageSize}&searchQuery=${searchQuery}&sortColumn=${sortColumn}&sortDirection=${sortDirection}&CustomerID=${CustomerID}&UserID=${UserID}&SearchColumns=${SearchColumns}`);
            return response.data;
        } catch (error) {

            console.error('Error fetching data:', error);
            throw error;
        }
    },
};

export default CustomerStockService;